import { Checkbox, DropdownMenuItem } from '@/components'
import type { FieldSchema } from '@/stores'
import { useDialogActions, useFilters, useFiltersActions } from '@/stores'

export interface FieldItemProps {
  dialogId: string
  schema: FieldSchema
}

export const FieldItem = ({ schema, dialogId }: FieldItemProps) => {
  const filters = useFilters()
  const { addFilter, removeFilter } = useFiltersActions()
  const { openDialog } = useDialogActions()

  if (schema.type === 'boolean') {
    const activeFilter = filters.find((f) => f.field === schema.field)

    return (
      <DropdownMenuItem
        onSelect={(e) => {
          e.preventDefault()
          if (activeFilter) {
            removeFilter(activeFilter.id)
          } else {
            addFilter({
              id: crypto.randomUUID(),
              field: schema.field,
              operator: 'equals',
              value: true,
            })
          }
        }}
      >
        <Checkbox checked={!!activeFilter} className="pointer-events-none" />
        <span>{schema.label}</span>
      </DropdownMenuItem>
    )
  }
  return (
    <DropdownMenuItem
      key={schema.field}
      onClick={() => openDialog(dialogId, { schema })}
    >
      {schema.label}
    </DropdownMenuItem>
  )
}
